module.exports = __webpack_public_path__ + "static/Building-Sketches-Mobile1-aea2d87d4f92ecc8a4fd7d844ca3781e.jpg";